import { useApi } from '@hero/context';

import type { UseWalletBalanceApi } from './types';
import { useQueryAPI } from '../../utils';

/**
 * Get current user wallet. Returns the full Wallet object (balance, currency, holder, status, etc.).
 * API from ApiProvider (useApi()); pass apiConfig to override apiFn, etc.
 *
 * Hook API: {@link UseWalletBalanceApi}
 */
export const useWalletBalanceApi: UseWalletBalanceApi = (apiConfig) => {
  const api = useApi();
  return useQueryAPI({
    entity: 'wallet',
    apiFn: api.payment.getCurrentUserBalance,
    query: undefined,
    apiConfig,
  });
};
